import { EMessage } from '../model';

export const triggerWebcamPermission = (
  onSuccess: () => void,
  onFail: (message: EMessage) => void
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const navigator = window.navigator as any;

  navigator.getUserMedia =
    navigator.getUserMedia ||
    navigator.webkitGetUserMedia ||
    navigator.mozGetUserMedia ||
    navigator.msGetUserMedia;

  if (navigator.getUserMedia) {
    navigator.getUserMedia(
      { video: { width: 640, height: 450 } },
      onSuccess,
      () => {
        onFail(EMessage.webcamError);
      }
    );
  } else if (navigator.mediaDevices) {
    // Safari fix
    navigator.mediaDevices.getUserMedia({ video: true }).then(
      (stream: MediaStream) => {
        stream.getVideoTracks()[0].stop();
        onSuccess();
      },
      () => {
        onFail(EMessage.webcamError);
      }
    );
  } else {
    onFail(EMessage.genericError);
  }
};
